// extracted by mini-css-extract-plugin
export default {"root":"InfoSection_root__rauyA","label":"InfoSection_label__upxzP","value":"InfoSection_value__WkktF"};